import CampoTexto from '../CampoTexto';
import Botao from '../Botao';
import Mensagem from '../Mensagem';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contextos/AuthContext'; // Importa o hook useAuth do contexto de autenticação para acessar o estado do usuário logado e funções relacionadas à 
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'; // Importa o hook useGoogleReCaptcha para integrar o reCAPTCHA v3 do Google, que ajuda a proteger o formulário contra bots e abusos automatizados

import './Login.css';

const Login = ({obrigatorio, editavel, exibir, aoFechar, onLoginSuccess}) => {
        /*
    Const Login recebe as props:
        exibir: controla se o componente de login deve ser exibido ou não
        aoFechar: função que será chamada quando o usuário fechar o componente de login
        aoLoginSuccess: função que será chamada quando o login for bem sucedido. Esta função é passada do componente pai (Header) para que ele possa atualizar o estado do usuário logado
    */
    
    /*
    Definindo os estados para os campos do formulário
    Esses estados serão atualizados conforme o usuário digita nos campos
    useState é um Hook do React que permite adicionar o estado a um componente funcional
    Cada useState retorna um par: o valor atual do estado e uma função para atualizá-lo
    */
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [mensagem, setMensagem] = useState({ texto: '', tipo: '' });//Controla o state dos dados do componente Mensagem para exibir feedback ao usuário

    const [carregando, setCarregando] = useState(false);//Para controlar o state de carregamento durante a requisição

    const { executeRecaptcha } = useGoogleReCaptcha();

    const aoLogar = async(evento) => {
        evento.preventDefault();

        setCarregando (true); // Trava o botão cadastrar durante a requisição
        // Limpa mensagens anteriores
        setMensagem({ texto: '', tipo: '' });

        // ✅ Gera o token antes de enviar
        if (!executeRecaptcha) {
            setMensagem({ texto: 'reCAPTCHA não carregado.', tipo: 'erro' });
            return;
        }

        // Chama a função executeRecaptcha com o nome da ação 'login' para gerar o token do reCAPTCHA
        const tokenCaptcha = await executeRecaptcha('login'); // ← nome da ação
        
        // Monta o objeto com os estados que você já tem (email, senha)
        const dadosParaEnvio = {
          email: email,
          senha: senha,
          tokenCaptcha: tokenCaptcha // Adiciona o token do reCAPTCHA ao objeto de dados que será enviado para o backend
        };
        
        try  {
            // Usa a variável de ambiente que agora está funcionando
            // O React substitui isso em tempo de execução. A variável baseUrl conterá a URL da API definida no arquivo .env
            const url =  `${process.env.REACT_APP_API_URL}/logar`;
            // Envia os dados do usuário para a API
            const resposta = await fetch(url, {  
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  
                },
                body: JSON.stringify(dadosParaEnvio),
                credentials: 'include' // <--- ESSENCIAL para a sessão funcionar
              });

              if (resposta.ok) {
                const dadosRetorno = await resposta.json();   
                if (dadosRetorno.status === 'sucesso') {

                    setMensagem({ texto: dadosRetorno.mensagem, tipo: dadosRetorno.status });
                    // Limpa os campos após o envio
                    setEmail('');
                    setSenha('');
                    onLoginSuccess(dadosRetorno.dados); // Esta é a prop que passamos no passo anterior. Ela tem uma propriedade que são os dados do usuário, que serão recebidos por dadosRetorno.dados da chamada do backend e atualiza no header e encadea atualizando o contexto do login. 
                    setMensagem({ texto: '', tipo: '' });
                    setCarregando (false); // Destrava o botão cadastrar após o processamento da requisição
                    return;

                }else {
                    setMensagem({ texto: dadosRetorno.mensagem, tipo: dadosRetorno.status });
                    setCarregando (false); // Destrava o botão cadastrar após o processamento da requisição
                  return;
                } 
                 
              }else {
                /// Aqui o PHP enviou um erro proposital (ex: 400 Bad Request)
                const erroRetorno = await resposta.json();
                setMensagem({ 
                            texto: erroRetorno.mensagem || "Erro ao processar a solicitação.", 
                            tipo: erroRetorno.status || 'erro'});
                setCarregando (false); // Destrava o botão cadastrar após o processamento da requisição
                }


        } catch (error) {
            setMensagem({ texto: error.message, tipo: 'erro' });
            setCarregando (false); // Destrava o botão cadastrar após o processamento da requisição
        }       
    }
    
    if (!exibir) return null; // Não renderiza a tela de login se o estado for falso
    
    //Se exibir for true, renderiza o modal de login
    return (  
            <div className="modal-overlay container-fluid mt-0 mb-0">
                {/* O stopPropagation impede que o modal feche ao clicar dentro da caixa branca */}
                <div className="modal-conteudo bg-light text-black p-4 shadow" 
                onClick={e => e.stopPropagation()}>

                {/* Botão de fechar o modal */}
                <button className="btn-fechar bg-dark" onClick={aoFechar}>&times;</button>   


                    <h2 className="display-5 text-primary-emphasis text-center mt-5 fw-medium">Login do Site</h2>
                    <form id='form' onSubmit={aoLogar}>
                        <div className="row mb-3 justify-content-md-center ">   
                            <CampoTexto 
                                label=""
                                labelClass="form-label fs-5"
                                className="form-control form-control-lg fs-3 text shadow p-3 mb-5 bg-body-secondary rounded "
                                wrapperClass="col-lg-2 w-100"
                                tipo="email"
                                placeholder="email"
                                obrigatorio={obrigatorio}
                                editavel={!editavel}
                                tamanhoMaximo={256}
                                nome="email"
                                id="email"
                                /*O valor do campo será controlado pelo estado email */
                                valor={email} 
                                /*Quando o usuário digitar algo, a função setEmail será chamada para atualizar o estado*/
                                aoDigitado={valor => setEmail(valor)}
                            />
                        </div> 

                        <div className="row mb-3 justify-content-md-center">
                            <CampoTexto
                                label=""   
                                labelClass="form-label fs-5"
                                className="form-control form-control-lg fs-3 text shadow p-3 mb-5 bg-body-secondary rounded"
                                wrapperClass="col-md-auto w-75"
                                tipo="password"
                                placeholder="senha"
                                obrigatorio={obrigatorio}
                                editavel={!editavel}
                                tamanhoMaximo={20}
                                nome="senha"
                                id="senha"
                                /*O valor do campo será controlado pelo estado senha */
                                valor={senha} 
                                /*Quando o usuário digitar algo, a função setSenha será chamada para atualizar o estado*/
                                aoDigitado={valor => setSenha(valor)}
                                />   
                        </div>  

                        {/* Mensagem de erro ou sucesso */}
                        <Mensagem mensagem={mensagem.texto} tipo={mensagem.tipo} />

                        <div className="row mb-3 justify-content-md-center">
                            <div className='col-md-auto w-50'>
                                {/* O botão de cadastro é desativado enquanto o carregamento está em andamento */}
                                <Botao className="btn btn-outline-primary btn-lg w-100 text-primary-emphasis fs-2" tipo="submit" aoClicar={null} disabled={carregando} >
                                        {carregando ? 'Enviando...' : 'Entrar'}
                                </Botao>
                            </div>
                        </div>    
                        
                        <div className="row mt-5 mb-3 justify-content-md-center">
                            <div className='col-md-auto'>
                                <span className="fs-5"></span>
                            </div>
                            <div className='col-md-auto badge fs-5'>
                                <Link 
                                    to="/reset-senha"
                                    onClick={aoFechar} // Fecha o modal de login ao clicar no link
                                    >
                                    Esqueci minha senha
                                </Link>
                            </div>    
                        </div>    
                    </form>
                </div>
            </div>
    );
}


export default Login